export default [
  // 获取会议详情
  {
    name: 'meeting-detail',
    config: {
      url: '/umeet/instant/info',
      method: 'get'
    }
  },
  // 获取配置在美信后台「其他配置」里的美信下载地址
  {
    name: 'mission-download-url',
    config: {
      url: '/j/MissionVideoMeeting',
      method: 'get'
    }
  },
  {
    name: 'get-wxpng',
    config: {
      url: '/umeet/instant/fetch/meeting/qrCode1',
      method: 'get',
    }
  },
  {
    name: 'get-wxpng-mx',
    config: {
      url: '/umeet/instant/fetch/meeting/qrCode1',
      method: 'get',
    }
  }
]
